import React from 'react';
import PropTypes from 'prop-types';
import './Button.css';

const Button = (props) => {
  const { className, children, ...allProps } = props;

  let classNameProp = [''];
  if (className) {
    classNameProp.push(className);
  }

  let assignedClass = classNameProp.join(' ');

  return (
    <button
      type="button"   // ✅ THIS FIXES THE RELOAD
      className={assignedClass}
      {...allProps}
    >
      {children}
    </button>
  );
};

Button.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
};

export default Button;